<div class="uk-container">
	<div class="ServicesHeading">
		<div class="ServicesHeading_Title">
			<h1>Корзина</h1>
		</div>
	</div>
</div>

<div *ngIf="!cartService.cart && !loadingState" class="uk-container">
	<div class="uk-alert-warning" uk-alert>
		<h3>Ваша корзина пуста</h3>
		<p>Самое время <a routerLink="/">отправится за покупками</a>!</p>
	</div>
</div>

<div *ngIf="cartService.cart && cartService.cart.ITEMS.length > 0">
	<div class="Basket">
		<div class="uk-container">
			<div class="ContainerSmall">
				<section *ngFor="let item of cartService.cart.ITEMS" class="Basket_Item">
					<div class="uk-grid" uk-grid>
						<div class="uk-width-2-5 uk-width-1-2@m uk-flex uk-flex-middle">
							<a [routerLink]="item.PROVIDER_DATA.DETAIL_PAGE_URL">{{item.PROVIDER_DATA.NAME}}</a>
						</div>

						<div class="uk-width-2-5 uk-width-1-4@m uk-flex uk-flex-middle">
							<app-touchspin
								[value]="item.QUANTITY"
								[max]="10"
								(change)="updateQuantity(item, $event)"
							></app-touchspin>
						</div>

						<div class="uk-width-1-5 uk-width-1-4@m uk-flex uk-flex-middle uk-flex-right">
							<div class="uk-flex uk-flex-column">
								<span *ngIf="item.PRICE_BASE !== item.PRICE" class="Basket_Item_Price" style="text-decoration: line-through">
									<span *ngIf="item.PRICE_ARR.QUANTITY_FROM">от </span>{{(item.PRICE_BASE * item.QUANTITY) | currency:item.PROVIDER_DATA.CURRENCY:'symbol':'1.0-0'}}
								</span>
								<span class="Basket_Item_Price">
									<span *ngIf="item.PRICE_ARR.QUANTITY_FROM">от </span>{{(item.PRICE * item.QUANTITY) | currency:item.PROVIDER_DATA.CURRENCY:'symbol':'1.0-0'}}
								</span>
							</div>
							<button class="Basket_Item_CloseBtn IconItem IconItem--close" type="button" (click)="removeFromCart(item.OFFER_ID)">
								<img src="/assets/img/icon/close.svg" uk-svg>
							</button>
						</div>
					</div>
				</section>

				<div class="Basket_Sum uk-flex uk-flex-column uk-flex-bottom">
					<div *ngIf="cartService.cart.DISCOUNT_VALUE"><strong>Общая стоимость товаров:</strong> {{cartService.cart.BASKET_PRICE_BASE | currency:totalCurrency:'symbol':'1.0-0'}}</div>
					<div *ngIf="cartService.cart.DISCOUNT_VALUE"><strong>Общая скидка:</strong> {{cartService.cart.DISCOUNT_VALUE | currency:totalCurrency:'symbol':'1.0-0'}}</div>
					<div><strong>Итого:</strong> {{cartService.cart.BASKET_PRICE | currency:totalCurrency:'symbol':'1.0-0'}}</div>
				</div>

				<p *ngIf="itemsPriceFromCount" class="uk-text-right">Обращаем внимание, что {{ itemsPriceFromCount }} услуг из Вашего заказа имеет индивидуальную расчетную стоимости и конфигурируется специалистом в зависимости от стоящих в проекте задач. После оформления заказа с Вами свяжется менеджер и сообщит конечную сумму заказа.</p>
			</div>
		</div>
	</div>

	<cart-checkout [paySystems]="paySystems" [deliveries]="deliveries"></cart-checkout>
</div>
